<template>
  <div class="th" role="status" aria-live="polite">
    <transition-group name="th">
      <div v-for="item in items" :key="item.id" :class="['th-item', 'th-' + item.kind]">
        <i :class="['mdi', item.kind === 'error' ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline']" aria-hidden="true"></i>
        <span>{{ item.text }}</span>
        <router-link v-if="item.action" :to="item.action.to" class="th-action">{{ item.action.label }}</router-link>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastState } from '../lib/toast';

export default {
  name: 'ToastHost',
  computed: { items() { return toastState.items; } }
};
</script>

<style scoped>
.th{position:fixed;z-index:300;left:50%;bottom:24px;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:8px;
  width:min(520px,calc(100vw - 32px));pointer-events:none}
.th-item{display:flex;gap:10px;align-items:flex-start;padding:12px 16px;border-radius:12px;background:#1F2328;color:#fff;
  font:500 14px/1.45 var(--font-body);box-shadow:0 10px 30px rgba(31,35,40,.25);pointer-events:auto}
.th-item span{color:#fff}
.th-item .mdi{font-size:18px;line-height:20px;color:#8FD3A8}
.th-item.th-error .mdi{color:#F5A99F}
.th-action{margin-left:auto;flex:0 0 auto;align-self:center;display:inline-flex;align-items:center;min-height:32px;padding:4px 12px;
  border:1px solid rgba(255,255,255,.45);border-radius:8px;color:#fff!important;font-weight:600;text-decoration:none;white-space:nowrap}
.th-action:hover{background:rgba(255,255,255,.12)}
.th-action:focus-visible{outline:2px solid #F08A68;outline-offset:2px}
.th-enter-active,.th-leave-active{transition:opacity .2s ease,transform .2s ease}
.th-enter,.th-leave-to{opacity:0;transform:translateY(8px)}
@media(prefers-reduced-motion:reduce){.th-enter-active,.th-leave-active{transition:none}}
</style>
